import { Injectable, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MonoTypeOperatorFunction } from 'rxjs';

import { StorageService } from '../storage/storage.service';

/**
 * Persiste o estado dos filtros de uma tela no localStorage, para que ao entrar
 * num detalhe e voltar (ou dar F5) os filtros continuem aplicados. Uma chave por tela.
 *
 * Uso (no componente de listagem, que estende BaseComponent):
 *   ngOnInit() {
 *     this.filtroPersistente.vincular('conferencias-de-fatura', this.formGroup, this.takeUntilDestroyed());
 *     this.carregarLista();
 *   }
 *   limparForm() {
 *     this.formGroup.reset();
 *     this.filtroPersistente.limpar('conferencias-de-fatura');
 *     this.carregarLista();
 *   }
 */
@Injectable({
  providedIn: 'root',
})
export class FiltroPersistenteService {
  private storage = inject(StorageService);
  private readonly PREFIXO = 'filtro:';

  /**
   * Restaura o filtro salvo no form (sem disparar carregamento) e passa a salvar
   * automaticamente a cada mudança. Chamar no ngOnInit ANTES de carregar a lista.
   */
  vincular(
    chave: string,
    form: FormGroup,
    takeUntilDestroyed: MonoTypeOperatorFunction<unknown>
  ): void {
    const salvo = this.storage.getItem<Record<string, unknown>>(this.chave(chave));

    if (salvo) {
      form.patchValue(salvo, { emitEvent: false });
    }

    form.valueChanges
      .pipe(takeUntilDestroyed)
      .subscribe((valor) => this.storage.setItem(this.chave(chave), valor));
  }

  /** Remove o filtro salvo da tela (chamar no botão Limpar). */
  limpar(chave: string): void {
    this.storage.removeItem(this.chave(chave));
  }

  private chave(chave: string): string {
    return `${this.PREFIXO}${chave}`;
  }
}
